import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'
import { throttle } from '~/utils/timing'

/* global sessionStorage */

export default class Sidebar extends Controller {
  static targets = ['menu', 'burger', 'scroll']
  static values = {
    opened: { type: Boolean, default: false }
  }

  connect () {
    this.#restoreScrollPosition()
    this.#setupScrollListener()
    this.#setupBeforeUnloadListener()
  }

  disconnect () {
    if (this.hasScrollTarget && this.scrollTarget.scrollTop > 0) {
      this.#saveScrollPosition()
    }
  }

  #saveScrollPosition () {
    if (!this.hasScrollTarget) return

    const scrollPosition = this.scrollTarget.scrollTop
    sessionStorage.setItem('sidebar-scroll-position', scrollPosition)
  }

  #restoreScrollPosition () {
    const savedPosition = sessionStorage.getItem('sidebar-scroll-position')

    if (savedPosition && this.hasScrollTarget) {
      const position = parseInt(savedPosition, 10)
      this.scrollTarget.scrollTop = position
    }
  }

  #setupScrollListener () {
    if (!this.hasScrollTarget) return

    const throttledSave = throttle(() => this.#saveScrollPosition(), 500)

    this.scrollTarget.addEventListener('scroll', throttledSave)
  }

  #setupBeforeUnloadListener () {
    document.addEventListener('turbo:before-visit', () => {
      this.#saveScrollPosition()
    })

    window.addEventListener('beforeunload', () => {
      this.#saveScrollPosition()
    })
  }

  openedValueChanged (value) {
    if (value === true) {
      this.element.classList.add('body-overflow')
      if (this.hasMenuTarget) this.menuTarget.classList.add('sidebar__nav-mobile_open')
      if (this.hasBurgerTarget) this.burgerTarget.classList.add('sidebar__burger-opened')
    } else {
      this.element.classList.remove('body-overflow')
      if (this.hasMenuTarget) this.menuTarget.classList.remove('sidebar__nav-mobile_open')
      if (this.hasBurgerTarget) this.burgerTarget.classList.remove('sidebar__burger-opened')
    }
  }

  toggle (e) {
    this.openedValue = !this.openedValue
  }
}

stimulus.register('sidebar', Sidebar)
